export default "__VITE_ASSET__CKTbIvgT__"